<template>
    <div>
        <button type="button" class="d-none" id="btn-modal-users" data-bs-toggle="modal" data-bs-target="#users-modal-form">Klik</button>
        <div class="modal" id="users-modal-form" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="row align-items-center mb-4">
                            <div class="col">
                                <div class="h1 m-0 display-tektur">
                                    {{label}} Data
                                </div>
                            </div>
                            <div class="col-auto">
                                <button type="button" class="btn btn-white-naked btn-icon" data-bs-dismiss="modal" aria-label="Close">
                                    <i class="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        </div>
                        <form v-on:submit.prevent="onSubmit">
                            <div class="d-block px-2">
                                <div class="form-group form-style-1">
                                    <label class="form-label">Nama Lengkap<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <input type="text" class="form-control" placeholder="Masukan nama" v-model="form.fullname" required oninvalid="this.setCustomValidity('Masukan nama')" oninput="this.setCustomValidity('')">
                                </div>
                                
                                <div class="form-group" v-if="form.role != 'student'">
                                    <label class="form-label">Sekolah<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <div class="form-select-wrapper form-select-style-1">
                                        <i class="fa-solid fa-caret-down"></i>
                                        <select class="form-select form-select-box-1" v-model="form.school_id" required oninvalid="this.setCustomValidity('Pilih Sekolah')" oninput="this.setCustomValidity('')">
                                            <option value="">Pilih Sekolah</option>
                                            <option v-for="(item, index) in dataSchool" :key="index" :value="item.id">{{ item.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group form-style-1">
                                    <label class="form-label">Username<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <input type="text" class="form-control" placeholder="Masukan username" v-model="form.username" required oninvalid="this.setCustomValidity('Masukan username')" oninput="this.setCustomValidity('')">
                                </div>
                                <div class="form-group form-style-1" v-if="form.role == 'student'">
                                    <label class="form-label">NISN<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <input type="text" class="form-control" placeholder="Masukan NISN" v-model="form.identity_number" required oninvalid="this.setCustomValidity('Masukan NISN')" oninput="this.setCustomValidity('')">
                                </div>
                                <div class="form-group form-style-1" v-if="form.role == 'student'">
                                    <label class="form-label">Kelas<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <input type="text" class="form-control" placeholder="Masukan Kelas" v-model="form.class" required oninvalid="this.setCustomValidity('Masukan Kelas')" oninput="this.setCustomValidity('')">
                                </div>
                                <div class="form-group" v-if="form.role == 'student'">
                                    <label class="form-label">Tahun Lulus<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <div class="form-select-wrapper form-select-style-1">
                                        <i class="fa-solid fa-caret-down"></i>
                                        <select class="form-select form-select-box-1" v-model="form.graduation_year" required oninvalid="this.setCustomValidity('Pilih Tahun Lulus')" oninput="this.setCustomValidity('')">
                                            <option value="">Pilih Tahun Lulus</option>
                                            <option v-for="(item, index) in dataYear" :key="index" :value="item.id">{{ item.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group form-style-1" v-if="form.role == 'student'">
                                    <label class="form-label">Nomor Handphone<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <input type="number" class="form-control" placeholder="Masukan Nomor Handphone" v-model="form.phone" required oninvalid="this.setCustomValidity('Masukan Nomor Handphone')" oninput="this.setCustomValidity('')">
                                </div>
                                <div class="form-group form-style-1" v-if="form.id == ''">
                                    <label class="form-label">Kata sandi<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <input type="password" class="form-control" placeholder="Masukan kata sandi" v-model="form.password" required oninvalid="this.setCustomValidity('Masukan kata sandi')" oninput="this.setCustomValidity('')">
                                </div>
                                <div class="form-group form-style-1" v-if="form.id == ''">
                                    <label class="form-label">Ulangi Kata sandi<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <input type="password" class="form-control" placeholder="Masukan kata sandi" v-model="form.retype_password" required oninvalid="this.setCustomValidity('Masukan ulangi kata sandi')" oninput="this.setCustomValidity('')">
                                </div>
                                <div class="form-group" v-if="this.form.role != 'consultant' && form.role != 'student'">
                                    <label class="form-label">Status<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <div class="row">
                                        <div class="col-4">
                                            <div class="form-select-wrapper form-select-style-1">
                                                <i class="fa-solid fa-caret-down"></i>
                                                <select class="form-select form-select-box-1" v-model="form.access" required oninvalid="this.setCustomValidity('Pilih Status')" oninput="this.setCustomValidity('')">
                                                    <option value="">Pilih Status</option>
                                                    <option value="counselor">Konselor</option>
                                                    <option value="viewers">Viewers</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between border-top pt-4">
                                <div class="d-block small">
                                    <i class="fa-solid fa-circle-exclamation me-2 text-pink"></i>Wajib diisi
                                </div>
                                <div class="d-flex align-items-center">
                                    <button type="button" class="btn btn-white-naked btn-s-1 me-3" data-bs-dismiss="modal" aria-label="Close" id="btn-close-modal-users">
                                        <div class="btn-s-1-inner">Batal</div>
                                    </button>
                                    <button type="submit" class="btn btn-primary btn-s-1" :disabled="waiting">
                                        <div class="btn-s-1-inner">{{ waiting ? 'Harap tunggu ...' : 'Simpan Data' }}</div>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";

export default {
    name: 'UsersForm',
    data() {
        return {
            label           : 'Tambah',
            form : {
                id                  : "",
                fullname            : "",
                school_id           : "",
                username            : "",
                identity_number     : "",
                class               : "",
                graduation_year     : "",
                phone               : "",
                password            : "",
                retype_password     : "",
                access              : "",
                role                : ""
            },
            dataSchool      : [],
            dataYear        : [],
            submitted       : false,
            waiting         : false
        }
    },
    validations: {
        form: {
            fullname: {
                required
            },
            school_id: {
                required
            },
            username: {
                required
            },
            password: {
                required
            },
            retype_password: {
                required
            },
            access: {
                required
            }
        }
    },
    methods: {
        loadForm: function(role="", params="") {
            this.getSchool();
            this.form.role  = role;
            this.form.class = "-";
            this.form.phone = 0;

            if(params == '') {
                this.label = 'Tambah';
                this.clearForm();
            } else {
                this.label = 'Ubah';
                this.getDataByID(params);
            }

            if(this.form.role == 'consultant') {
                this.form.access = 'counselor';
            }

            if(this.form.role == 'student') {
                this.form.access    = 'viewers';
                this.form.school_id = this.$parent.users.school_id;
                this.getYear();
            }
            
            document.getElementById('btn-modal-users').click();
        },
        reloadData: function() {
            document.getElementById('btn-close-modal-users').click();
            this.$parent.$children[0].$children[0].getData();
            this.clearForm();
        },
        clearForm: function() {
            for (let key in this.form) {
                if(key != 'role') {
                    this.form[key] = '';
                }
            }
        },
        onSubmit: function () {
            this.waiting    = true;
            this.submitted  = true;

            // stop here if form is invalid
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Harap lengkapi form',
                });

                this.waiting = false;
                return;
            } else {    
                if(this.form.password != this.form.retype_password) {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Password yang dimasukan tidak sama!',
                    });

                    this.waiting = false;
                    return;
                } else {
                    let formData = new FormData();
                    for (let key in this.form) {
                        formData.append(key, this.form[key]);
                    }

                    this.$http.post(process.env.VUE_APP_APIHOST + 'users/save', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                            if (response.data.status) {
                                this.$swal({
                                    icon: 'success',
                                    title: 'Success',
                                    text: response.data.message,
                                    confirmButtonText: 'OK'
                                }).then((result) => {
                                    if (result.value) {
                                        this.reloadData();
                                    }
                                });
                            } else {
                                this.$swal({
                                    icon: 'warning',
                                    title: 'Ups!',
                                    text: response.data.message,
                                });
                            }
                            this.waiting = false;
                        })
                    .catch(function () {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: 'Please check your internet connection.',
                        });
                        this.waiting = false;
                        return;
                    });
                }
            }
        },
        getDataByID: function(id) {
            if(id != '') {
                let uri         = process.env.VUE_APP_APIHOST+'users/detail';
                this.$http.get(uri,{
                    params : {
                        id : id,
                    }
                }).then(res => {
                    if(res.data.status) {
                        let datasets = res.data.data;

                        for (let key in datasets) {
                            if (Object.prototype.hasOwnProperty.call(datasets, key)) {
                                this.form[key] = datasets[key];

                                if(key == 'graduation_year' && !datasets[key]) {
                                    this.form.graduation_year = '';
                                }

                                if(key == 'password') {
                                    this.form.retype_password = this.form.password;
                                }
                            }
                        }
                    }
                });
            }
        },
        getSchool: function() {
            let uri         = process.env.VUE_APP_APIHOST+'school/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000,
                    partner  : 1
                }
            }).then(res => {
                this.dataSchool = res.data.data;
            });
        },
        getYear: function() {
            if(this.dataYear.length > 0) {
                return;
            }

            let uri         = process.env.VUE_APP_APIHOST+'year/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataYear = res.data.data;
            });
        }
    },
}
</script>
